import { FormControlLabel as MuiFormControlLabel, FormHelperText as MaterialFormHelperText } from '@mui/material';
import { TopBar } from 'shared-ui';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  gap: 24px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.palette.common.white};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  border: 1px solid ${({ theme }) => theme.palette.grey[200]};
`;

export const PermissionRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 200px 240px;
  align-items: center;
  padding-top: 4px;
  padding-bottom: 4px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[200]};
  margin-left: 80px;

  &:last-child {
    border-bottom: none;
  }
`;

export const SectionHeader = styled.div`
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[200]};
  min-height: 50px;

  &:last-child {
    border-bottom: none;
  }
`;

export const PermissionTitle = styled.div`
  font-weight: 500;
`;

export const RadioGroupContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
`;

export const DataPermissionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 36px;
`;

export const DataPermissionsTitle = styled.div`
  font-weight: 700;
`;

export const SelectFieldsContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(auto, 330px) minmax(auto, 530px);
  gap: 16px;
`;

export const FormControlLabel = styled(MuiFormControlLabel)`
  & .MuiFormControlLabel-label {
    text-transform: uppercase !important;
    font-weight: 700 !important;
  }
`;

export const TopBarButton = styled(TopBar.Button)`
  min-width: 50px;
  width: 100px;
`;

export const FormHelperText = styled(MaterialFormHelperText)(
  ({ theme: { palette } }) => css`
    display: block;
    font-weight: 700;
    color: ${palette.error.main};
  `,
);
